module.exports = [
    {
        "title": "Studio#Mechant.tv",
        "fullImage": "mechant.jpg",
        "tags": [
            "Nuxt",
            "Three.js"
        ],
        "url": "https://www.mechant.tv/",
        "year": "2023",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": []
    },
    {
        "title": "AI#Gallery",
        "fullImage": "ai_gallery.jpg",
        "tags": [
            "Nuxt",
            "Three.js"
        ],
        "url": "https://ai-gallery.ultranoir.com/",
        "year": "2023",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": [
            {
                "type": "FWA",
                "name": "Site of the day",
                "date": "23/02/2023"
            }
        ]
    },
    {
        "title": "Keakr#Corporate",
        "fullImage": "keakr.jpg",
        "tags": [
            "Nuxt",
            "Strapi"
        ],
        "url": "https://corporate.keakr.io/",
        "year": "2022",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": []
    },
    {
        "title": "Moët Hennesy#Cloudy bay",
        "fullImage": "cloudyBay.png",
        "tags": [
            "React",
            "Gatsby",
            "Drupal 8"
        ],
        "url": "https://www.ultranoir.com/fr/projets/cloudybayconz-1536.html",
        "year": "2022",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": []
    },
    {
        "title": "Montblanc#Haus",
        "fullImage": "montblanc_haus.png",
        "tags": [
            "HTML5",
            "CSS3",
            "JavaScript"
        ],
        "url": "https://www.ultranoir.com/fr/projets/montblanc-haus-1539.html",
        "year": "2022",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": []
    },
    {
        "title": "Diptyque#Unleash the Rose",
        "fullImage": "diptyque_unleash.png",
        "tags": [
            "HTML5",
            "CSS3",
            "JavaScript",
            "Nuxts.js",
            "Vue.js"
        ],
        "url": "https://www.ultranoir.com/fr/projets/unleash-the-rose-1530.html",
        "year": "2022",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": []
    },
    {
        "title": "Self#Scenter<span>(Comme des Garçons Parfums)</span>",
        "fullImage": "cdg.png",
        "tags": [
            "JavaScript",
            "Three.js",
            "Shaders",
            "Node.js",
            "GSAP",
            "SASS"
        ],
        "url": "http://self-scenter.comme-des-garcons-parfum.com/",
        "year": "2019",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": [
            {
                "type": "FWA",
                "name": "Site of the day",
                "date": "24/02/2020"
            }
        ]
    },
    {
        "title": "ultranoir#Website",
        "fullImage": "ultranoirv4.jpg",
        "tags": [
            "HTML5",
            "SASS",
            "JavaScript",
            "Vue.js",
            "Three.js",
            "GLSL",
            "GSAP"
        ],
        "url": "http://www.ultranoir.com/",
        "year": "2019",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": [
            {
                "type": "Awwwards",
                "name": "Site of the day",
                "date": "05/03/2019"
            },
            {
                "type": "Awwwards",
                "name": "Developer awards",
                "date": "05/03/2019"
            },
            {
                "type": "Awwwards",
                "name": "Mobile excellence awards",
                "date": "05/03/2019"
            },
            {
                "type": "FWA",
                "name": "Site of the day",
                "date": "28/02/2019"
            },
            {
                "type": "CSS Design Awards",
                "name": "Site of the day",
                "date": "05/03/2019"
            },
        ]
    },
    {
        "title": "VIPPING#Website",
        "fullImage": "vipping.jpg",
        "tags": [
            "HTML5",
            "SASS",
            "JavaScript",
            "Browserify",
            "Gulp",
            "GSAP"
        ],
        "url": "https://www.vipping.luxury/",
        "year": "2018",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": []
    },
    {
        "title": "NATIXIS#Intranet",
        "fullImage": "natixis_intranet.png",
        "tags": [
            "HTML5",
            "SASS",
            "JavaScript",
            "Underscore.js"
        ],
        "url": "https://www.ultranoir.com/fr/projets/anytime-1455.html",
        "year": "2017",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": []
    },
    {
        "title": "École#multimedia",
        "fullImage": "ecoleMultimedia2.jpg",
        "tags": [
            "HTML5",
            "SASS",
            "JavaScript",
            "Browserify",
            "Gulp",
            "GSAP"
        ],
        "url": "https://www.ecole-multimedia.com/",
        "year": "2016",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": []
    },
    {
        "title": "Virtual#Reality",
        "fullImage": "vrUltranoir.jpg",
        "tags": [
            "HTML5",
            "SASS",
            "JavaScript",
            "Browserify",
            "Gulp",
            "GSAP"
        ],
        "url": "http://vr.ultranoir.com/",
        "year": "2016",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": [
            {
                "type": "Awwwards",
                "name": "Site of the day",
                "date": "25/05/2016"
            },
            {
                "type": "CSS Awards",
                "name": "Site of the day",
                "date": "20/05/2016"
            },
            {
                "type": "CSS Design Awards",
                "name": "Site of the day",
                "date": "26/05/2016"
            }
        ]
    },
    {
        "title": "DIOR ADDICT#ULTRA-GLOSS",
        "fullImage": "diorUltraGlossApp.jpg",
        "tags": [
            "HTML5",
            "SASS",
            "React.js",
            "Cordova",
            "Gulp"
        ],
        "url": "https://www.ultranoir.com/fr/projets/dior-addict-ultra-gloss-1436.html",
        "year": "2016",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": []
    },
    {
        "title": "150 ans#Printemps",
        "fullImage": "printemps.jpg",
        "tags": [
            "HTML5",
            "SASS",
            "Vue.js",
            "Gulp",
            "GSAP"
        ],
        "url": "https://vimeo.com/131560433",
        "year": "2015",
        "agency": "grouek",
        "agencyUrl": "http://grouek.com/",
        "awards": []
    },
    {
        "title": "Montres#Dewitt",
        "fullImage": "dewitt.jpg",
        "tags": [
            "HTML5",
            "CSS3",
            "Require.js",
            "GSAP",
            "Grunt",
            "Underscore.js"
        ],
        "url": "http://www.dewitt.ch/",
        "year": "2014",
        "agency": "ultranoir",
        "agencyUrl": "http://www.ultranoir.com/",
        "awards": [
            {
                "type": "Awwwards",
                "name": "Site of the day",
                "date": "18/09/2014"
            },
            {
                "type": "FWA",
                "name": "Site of the day",
                "date": "20/10/2014"
            }
        ]
    }
]



// WEBPACK FOOTER //
// ./src/components/Projects/projects.js